import React from 'react';
import GetAppPoint from './GetAppPoint';
import { webConfig } from '../../utils/webConfig';
import { Text } from '../Donee/components/common/Text/Text';
import { Divider, IconButton } from '@mui/material';
import { Icon } from '../Donee/components/common';
import { Button } from '../ui';

export const getMobileAppHeading = (
    <Text
        variant={'large'}
        weight={'extraBold'}
    >
        Track your giving history and more in the app
    </Text>
);

export const getMobileAppPoints = (
    <>
        <GetAppPoint text={'Give next time in 3 easy taps'} />
        <GetAppPoint text={'Use reminders to give consistently'} />
        <GetAppPoint
            text={'See personalized analytics to help with your giving journey'}
        />
    </>
);

interface GetAppMobileProps {
    isLoading: boolean;
    isDisabled: boolean;
    handleDownload: () => unknown;
    onClose?: () => unknown;
}

const GetAppMobile: React.FC<GetAppMobileProps> = ({
    isLoading,
    isDisabled,
    handleDownload,
    onClose,
}) => {
    return (
        <div className="w-max-full md:w-max-[327px] block md:hidden">
            <div className="flex justify-end mt-5 mx-4">
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                >
                    <Icon name={'close-icon'} />
                </IconButton>
            </div>
            <Divider className="my-4" />
            <div className="flex flex-col align-middle mx-16">
                <img
                    src={webConfig.getAppMobileUrl}
                    alt="Get the Givelify app"
                    title="Get the Givelify app"
                />
                <div className="mt-12 mb-3">{getMobileAppHeading}</div>
                {getMobileAppPoints}
                <Button
                    variant="give"
                    loading={isLoading}
                    disabled={isDisabled}
                    color={'secondary'}
                    onClick={handleDownload}
                    className="mt-12 mb-5"
                >
                    Get the App
                </Button>
            </div>
        </div>
    );
};

export default GetAppMobile;
